import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { environment } from './../../../../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/handle-error.service';
import { RequestCRUD } from 'src/app/shared/services/abstract/request-crud.service';
import { EstablecimientoEntry } from 'src/app/shared/entrys/establecimiento.entry';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { Observable, of } from 'rxjs';
import { retry } from 'rxjs/operators';
import { ConsultaMisRNTEntry } from 'src/app/shared/entrys/consulta-mis-rnt.entry';
import { AuthService } from 'src/app/shared/services/auth.service';
import { TipoPrestador } from 'src/app/shared/enumeraciones/tipo-prestador.enum';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';


@Injectable()
export class ReportesSoloConsultaService implements RequestCRUD<EstablecimientoEntry, ResponseServiceModel> {
	private API_URL;
	private handleError: HandleError;
	constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private authService: AuthService, private enviromentGlobalService: EnviromentGlobalService) {
		this.API_URL = enviromentGlobalService.apiUrl;
		this.handleError = httpErrorHandler.createHandleError('ReportesService');
	}

	get(entry: any): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}

	// #region Filtros
	getEstadosRNT(): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/EstadosRnt`).pipe(
			retry(2)
		);
	}
	getDepartamentos(): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/departamento`).pipe(
			retry(2)
		);
	}
	getCategorias(): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/Categoria/Publica`).pipe(
			retry(2)
		);
	}
	getDatosGrafica(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/ConsultaRnt/ObtenerDatosGrafica`, entry).pipe(
			retry(2)
		);
	}
	getDatosTabla(entry: any, numeroPagina: number): Observable<ResponseServiceModel> {
		// tslint:disable-next-line:max-line-length
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/ConsultaRnt/ObtenerDatosGraficaDetalle?PageNumber=${numeroPagina}&PageSize=12`, entry).pipe(
			retry(2)
		);
	}
	// #endregion
	update(entry: EstablecimientoEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}
	create(entry: EstablecimientoEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}
	delete(entry: EstablecimientoEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}


}
